// @ts-nocheck

export const localeCodes =  [
  "en",
  "es",
  "de",
  "it",
  "pt",
  "ru",
  "ja",
  "fr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_251cbb0c",
      load: () => import("#nuxt-i18n/251cbb0c" /* webpackChunkName: "locale_en_46json_251cbb0c" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_16961691",
      load: () => import("#nuxt-i18n/16961691" /* webpackChunkName: "locale_es_46json_16961691" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_35dd5bbb",
      load: () => import("#nuxt-i18n/35dd5bbb" /* webpackChunkName: "locale_de_46json_35dd5bbb" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_75e4f1c4",
      load: () => import("#nuxt-i18n/75e4f1c4" /* webpackChunkName: "locale_it_46json_75e4f1c4" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_5953b09c",
      load: () => import("#nuxt-i18n/5953b09c" /* webpackChunkName: "locale_pt_46json_5953b09c" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_00a0f786",
      load: () => import("#nuxt-i18n/00a0f786" /* webpackChunkName: "locale_ru_46json_00a0f786" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_53a3c6ad",
      load: () => import("#nuxt-i18n/53a3c6ad" /* webpackChunkName: "locale_ja_46json_53a3c6ad" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_b9f86f81",
      load: () => import("#nuxt-i18n/b9f86f81" /* webpackChunkName: "locale_fr_46json_b9f86f81" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    type: "json"
  },
  {
    code: "es",
    name: "Spanish",
    language: "es-ES",
    type: "json"
  },
  {
    code: "de",
    name: "German",
    language: "de-DE",
    type: "json"
  },
  {
    code: "it",
    name: "Italian",
    language: "it-IT",
    type: "json"
  },
  {
    code: "pt",
    name: "Portuguese",
    language: "pt-BR",
    type: "json"
  },
  {
    code: "ru",
    name: "Russian",
    language: "ru-RU",
    type: "json"
  },
  {
    code: "ja",
    name: "Japanese",
    language: "ja-JP",
    type: "json"
  },
  {
    code: "fr",
    name: "Français",
    language: "fr-FR",
    type: "json"
  }
]

